import createReducer from 'shared/utils/createReducer';

import { MODAL_SIGN_OUT_TO_PROCEED } from '../constants/modalCodes';
import { ADD_MODAL, PREVENT_DUPLICATE_MODAL, PREVENT_MODAL_NOT_ALL_TRUE, ADD_MODAL_FORCE } from '../actions/addModal';
import { REMOVE_MODAL } from '../actions/removeModal';
import { CLEAR_MODAL_QUEUE } from '../actions/clearModalQueue';
import { GET_CURRENT_MODAL } from '../actions/getCurrentModal';


const unclearableModals = [MODAL_SIGN_OUT_TO_PROCEED];

export default createReducer({
  queue: [],
  currentModal: undefined,
  timerId: undefined,
  preventedModals: {},
}, {
  [ADD_MODAL]: (state, { meta }) => ({
    ...state,
    queue: [...state.queue, meta],
  }),

  [ADD_MODAL_FORCE]: (state, { meta }) => ({
    ...state,
    queue: [meta, ...state.queue],
  }),

  [REMOVE_MODAL]: (state, { meta: { id } }) => ({
    ...state,
    currentModal: undefined,
    timerId: undefined,
    queue: state.queue.filter(
      ({ id: curId }) => curId !== id,
    ),
  }),

  [CLEAR_MODAL_QUEUE]: (state) => ({
    ...state,
    currentModal: state.queue.some(({ typeId }) => unclearableModals.includes(typeId)) ? state.currentModal : undefined,
    timerId: undefined,
    queue: state.queue.filter(({ typeId }) => unclearableModals.includes(typeId)),
  }),

  [GET_CURRENT_MODAL]: (state, { payload: { currentModal, timerId } }) => ({
    ...state,
    currentModal,
    timerId,
  }),

  [PREVENT_DUPLICATE_MODAL]: (state, { meta }) => ({
    ...state,
    preventedModals: [...state.preventedModals, meta],
  }),

  [PREVENT_MODAL_NOT_ALL_TRUE]: (state, { meta }) => ({
    ...state,
    preventedModals: [...state.preventedModals, meta],
  }),
});
